// React
import React, { useEffect, useState } from "react";

// MUI
import {
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Collapse,
  Autocomplete,
  Paper,
  Tooltip,
  CircularProgress,
} from "@mui/material";

//MUI ICON
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoIcon from "@mui/icons-material/Info";
import SearchIcon from "@mui/icons-material/Search";

import moment from "moment";

// Formik
import { useFormik } from "formik";
import * as Yup from "yup";

//Components
import Dropzone from "components/Dropzone_one";
import CustomDropzone from "components/Dropzone";
import {
  GradientButton,
  GradientOutline,
  GradientButtonOutline,
  GradientShadow,
} from "components/GradientButton";
import Form from "components/Form/FormBorrow";

// API
import api from "_api";

// Other
import { Divider } from "antd";
import Swal from "sweetalert2";
import ReactDOM from "react-dom";
import SaveIcon from "assets/images/SaveIcon.svg";

// ฟังก์ชันสำหรับสร้าง validation schema ให้กับฟอร์ม
const generateValidationSchema = (productBoxes) => {
  // Dynamic validation fields from productBoxes
  const validationFields = productBoxes.reduce((schema, box) => {
    schema[`product_name_${box.id}`] =
      Yup.string().required(`โปรดระบุชื่อสินค้า`);
    // schema[`category_id_${box.id}`] = Yup.string().required(`โปรดระบุหมวดหมู่`);
    schema[`total_amount_${box.id}`] = Yup.number().required(`โปรดระบุจำนวน`);
    schema[`price_${box.id}`] = Yup.number().required(`โปรดระบุราคา`);
    // schema[`total_price_${box.id}`] =
    //   Yup.number().required(`โปรดระบุจำนวนทั้งหมด`);
    return schema;
  }, {});

  // Static validation fields
  const staticFields = {
    fullName: Yup.string().required("โปรดระบุชื่อ-สกุล"),
    idCardNumber: Yup.string()
      .length(13, "รหัสบัตรประชาชนต้องมี 13 หลัก")
      .matches(/^\d+$/, "รหัสบัตรประชาชนต้องเป็นตัวเลขเท่านั้น")
      .required("โปรดระบุรหัสบัตรประชาชน"),
    phoneNumber: Yup.string()
      .min(9, "หมายเลขโทรศัพท์ต้องมีอย่างน้อย 9 หลัก")
      .max(10, "หมายเลขโทรศัพท์กรอกได้มากสุด 10 หลัก")
      .matches(/^\d+$/, "หมายเลขโทรศัพท์ต้องเป็นตัวเลขเท่านั้น")
      .required("โปรดระบุหมายเลขโทรศัพท์"),
    address: Yup.string().required("โปรดระบุที่อยู่"),
  };

  // Merge dynamic and static fields
  return Yup.object({
    ...validationFields, // Dynamic fields
    ...staticFields, // Static fields
  });
};

// กำนหดตัวแปรสำหรับการดึงข่้อมูลไปแสดงผลใน Field ของผู้ที่มาซื้อ
const customerFields = [
  { label: "ชื่อ-นามสกุล", name: "fullName", type: "text", required: true },
  {
    label: "เลขบัตรประชาชน",
    name: "idCardNumber",
    type: "text",
    required: true,
  },
  { label: "เบอร์โทรศัพท์", name: "phoneNumber", type: "text", required: true },
  { label: "ที่อยู่", name: "address", type: "text", required: true },
];

// กำนหดตัวแปรสำหรับการดึงข่้อมูลไปแสดงผลใน Field หมวดหมู่
const categoryOptions = [
  { label: "เครื่องประดับ", id: 1 },
  { label: "อิเล็กทรอนิกส์", id: 2 },
  { label: "ทองคำ", id: 3 },
  { label: "พระเครื่อง", id: 4 },
  { label: "แบรนด์เนม", id: 5 },
  { label: "นาฬิกา", id: 6 },
];

const payment_channelOptions = [
  { label: "เงินสด", id: "เงินสด" },
  { label: "เงินโอน", id: "โอนผ่านธนาคาร" },
  { label: "เช็ค", id: "เช็ค" },
  { label: "บัตรเครดิต", id: "บัตรเครดิต" },
];

const ModalBorrow = ({ open, onClose, selectedProduct, fetchProductData }) => {
  // ตัวแปรสำหรับเก็บข้อมูลรูปภาพ
  const [files1, setFiles1] = useState([]);
  const [files2, setFiles2] = useState([]);
  const [error1, setError1] = useState(null);
  const [error2, setError2] = useState(null);
  const [initialProductUrls, setInitialProductUrls] = useState([]);
  const [deletedImageIds, setDeletedImageIds] = useState([]);

  //สรุปราคารวม order
  const [sumTotalPrice, setSumTotalPrice] = useState(0);

  // ตัวแปรสำหรับเก็บข้อของ Box แสดง Product
  const [productBoxes, setProductBoxes] = useState([
    { id: 1, isExpanded: false },
  ]);
  const [expandedRow, setExpandedRow] = useState(null); // เก็บการแสดงผลของ Row ในการ Explaned
  const [statusSave, setStatusSave] = useState(false); // เก็บ status หลังจากมีการเพิ่ม Box
  const [currentStep, setCurrentStep] = useState(1); // Track the current step
  // const [selectedOption, setSelectedOption] = useState(1); // For selecting the display count option
  const [isHovered, setIsHovered] = useState(false);
  const [activeButton, setActiveButton] = useState("pawnContract");

  //เก็บตัวแปร id หลังจากสร้าง product เสร็จ
  const [newIds, setNewIds] = useState([]);
  const [updateData, setUpdateData] = useState([]);

  // keep data order when create order success
  const [order, setOrder] = useState(null);

  // loading and status success when create order
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const forCreateLendOrder = async (values) => {
    try {
      const { data, isStatus } = await api.product.getProductForCreateLendOrder(
        values
      );

      if (isStatus) {
        if (!data || (Array.isArray(data) && data.length === 0)) {
          // แจ้งเตือนกรณีไม่พบ product_code
          alert("ไม่พบข้อมูล product_code");
          return;
        }

        setUpdateData((prevData) => {
          const newData = Array.isArray(data) ? data : [data];
          // รวมข้อมูลเดิมและข้อมูลใหม่เข้าไป
          const mergedData = [...prevData, ...newData];
          // ลบข้อมูลซ้ำตาม product_code
          return mergedData.filter(
            (item, index, self) =>
              self.findIndex((i) => i.product_code === item.product_code) ===
              index
          );
        });
      }
    } catch (error) {
      console.log("error", error);
      alert("เกิดข้อผิดพลาดในการดึงข้อมูล");
    }
  };

  const handleCallData = (productCode) => {
    forCreateLendOrder(productCode);
  };

  //ฟังก์ชันแสดง Explanded
  const handleExpandClick = (rowId) => {
    setExpandedRow(expandedRow === rowId ? null : rowId);
  };

  //ฟังก์ชันลบ Box
  const handleDeleteBox = (rowId) => {
    if (productBoxes.length > 1) {
      setProductBoxes((prevBoxes) =>
        prevBoxes.filter((box) => box.id !== rowId)
      );
    } else {
      alert("Cannot delete the last remaining box.");
    }
  };

  //ฟังก์ชันเปลี่ยนหน้า
  const handleNextStep = () => {
    setCurrentStep(currentStep + 1); // Go to the next "page"
  };

  //ฟังก์ชันสำหรับการเปลี่ยนหน้าแสดงผลใน Modal
  const handleBackToStep1 = () => {
    setCurrentStep(1); // Reset back to the first step if needed
  };

  // ฟังก์ชันเพิ่ม product box
  const addProductBox = () => {
    if (productBoxes.length < 15) {
      setProductBoxes([
        ...productBoxes,
        { id: productBoxes.length + 1, isExpanded: false },
      ]);
      setStatusSave(false);
    } else {
      alert("คุณสามารถเพิ่มสินค้าได้สูงสุด 15 รายการเท่านั้น");
    }
  };

  // ฟังก์ชัน explan
  const toggleExpand = (boxId) => {
    setProductBoxes(
      productBoxes.map((box) =>
        box.id === boxId ? { ...box, isExpanded: !box.isExpanded } : box
      )
    );
  };

  // สร้างรหัสตัวแปรตามจำนวน Box ที่เพิ่ม
  const generateInitialValues = (id) => ({
    // ฟิลด์ที่ยังใช้ id
    [`product_id_${id}`]: "",
    [`product_code_${id}`]: "",
    [`product_name_${id}`]: "",
    [`category_id_${id}`]: "",
    [`detail_${id}`]: "",
    [`blemishes_${id}`]: "",
    [`size_${id}`]: "",
    [`total_amount_${id}`]: "",
    [`total_amount_borrow_${id}`]: "",
    [`price_${id}`]: "",
    [`price_borrow_${id}`]: "",
    [`total_price_${id}`]: "",
    [`total_price_borrow_${id}`]: "",
    [`notes_${id}`]: "",
    [`images_${id}`]: [],

    // ฟิลด์ที่ไม่ใช้ id
    payment_channel: "",
    total_price_order: "",
    notes_order: "",
    return_date: "",
  });

  // นับจำนวน Box
  const productBoxCount = productBoxes.length;

  // console.log("display new id in array", productBoxes);

  // Function to convert object to FormData
  const transformObjectToFormData = (obj) => {
    const formData = new FormData();

    Object.entries(obj).forEach(([key, value]) => {
      if (
        (key === "category_id" ||
          key === "payment_channel" ||
          key === "market_channel") &&
        value &&
        value?.id
      ) {
        formData.append(key, value.id);
      } else if (key === "product" && Array.isArray(value)) {
        // แปลง product เป็น JSON string ก่อน
        value.forEach((item, index) => {
          formData.append(`${key}[${index}]`, JSON.stringify(item));
        });
      } else if (key === "customer" && value && typeof value === "object") {
        // ไม่ต้องแปลงเป็น array ถ้าเป็น object เดียว
        Object.entries(value).forEach(([subKey, subValue]) => {
          formData.append(`${key}[${subKey}]`, subValue);
        });
      } else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          formData.append(`${key}[${index}]`, item);
        });
      } else if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });

    return formData;
  };

  // Formik hook
  const formik = useFormik({
    initialValues: generateInitialValues(productBoxes),
    // validationSchema: generateValidationSchema(productBoxes),
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        // แปลง return_date จากจำนวนวันเป็นวันที่
        const calculatedReturnDate = moment()
          .add(values.return_date, "days") // ใช้ moment เพิ่มจำนวนวันที่ระบุ
          .format("YYYY-MM-DD"); // แปลงวันที่ให้อยู่ในรูปแบบที่ต้องการ

        // เตรียมข้อมูลลูกค้า
        const customerData = {
          fullName: values.fullName,
          idCardNumber: values.idCardNumber,
          phoneNumber: values.phoneNumber,
          address: values.address,
          file: files2.map((fileObj) => fileObj.file),
        };

        const customerFormData = transformObjectToFormData(customerData);
        const customerResponse = await api.product.createCustomer(
          customerFormData
        );

        if (customerResponse.isStatus) {
          // สร้างข้อมูลคำสั่งซื้อสำหรับแต่ละ product box
          const orderData = {
            product: productBoxes.map((box) => ({
              product_id: values[`product_id_${box.id}`],
              lenting_amount: values[`total_amount_borrow_${box.id}`],
              price: values[`price_borrow_${box.id}`],
              total_price: values[`total_price_borrow_${box.id}`],
              return_date: calculatedReturnDate,
              status: 5,
            })),
            customer: {
              id: customerResponse.data.id,
            },
            picture: files1.map((fileObj) => fileObj.file),
            payment_channel: values.payment_channel?.id,
            total_price_order: sumTotalPrice,
            notes_order: values.notes_order,
          };

          // ส่งคำสั่งซื้อทั้งหมดในครั้งเดียว
          const orderFormData = transformObjectToFormData(orderData);
          const orderResponse = await api.product.createLendOrder(
            orderFormData
          );

          if (!orderResponse.isStatus) {
            console.error("Error creating order.");
          } else {
            setOrder(orderResponse.data);

            setTimeout(() => {
              setIsSuccess(true);
              setLoading(false);
            }, 1000);
            // รีเซ็ตฟอร์มและสถานะ
            // setFiles1([]); // ล้างรูปภาพสินค้า
            // setFiles2([]); // ล้างรูปภาพลูกค้า
            // resetForm();
            // onClose();
            // fetchProductData();
            // setCurrentStep(1);
            // setProductBoxes([{ id: 1, isExpanded: false }]);
            // setNewIds([]);
          }
        } else {
          setLoading(false);
          console.error("Error creating customer.");
        }
      } catch (error) {
        setLoading(false);
        console.error("Error submitting form:", error);
        alert(`Error submitting form: ${error.message}`);
      }
    },
    validateOnChange: true,
    validateOnBlur: true,
  });

  const handlePrintPDF = async () => {
    if (order) {
      await api.product
        .getPrintPdfLendOrder(order?.createdOrder?.id)
        .then((res) => {
          const url = window.URL.createObjectURL(
            new Blob([res.data], { type: "application/pdf" })
          );
          window.open(url, "_blank");
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  const handleClose = () => {
    onClose();
    setFiles1([]); // ล้างรูปภาพสินค้า
    setFiles2([]); // ล้างรูปภาพลูกค้า
    formik.resetForm();
    setCurrentStep(1);
    setProductBoxes([{ id: 1, isExpanded: false }]);
    setNewIds([]);
    setIsSuccess(false);
    setLoading(false);
    fetchProductData();
  };

  // ฟังก์ชันลบรูป
  const handleImageDelete = (boxId, imageIndex) => {
    const currentImages = formik.values[`images_${boxId}`] || [];

    // Safeguard against undefined or null images array
    const updatedImages = currentImages.filter(
      (_, index) => index !== imageIndex
    );

    formik.setFieldValue(`images_${boxId}`, updatedImages);
  };

  // ฟังก์ชันการแสดงฟิลด์ Customer
  const renderFields = (fields) => {
    return fields.map((field, index) => (
      <React.Fragment key={index}>
        <Grid item xs={12} sm={12} sx={{ margin: 2 }}>
          <Box display="flex" alignItems="center">
            <Typography
              variant="subtitle1"
              sx={{ width: "200px", whiteSpace: "nowrap" }}
            >
              {field.label}
              {field.required && (
                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
              )}
            </Typography>

            {field.type === "autocomplete" ? (
              <Autocomplete
                id={field.name}
                options={categoryOptions}
                getOptionLabel={(option) => option.label}
                value={formik.values.category_id}
                onChange={(event, newValue) => {
                  if (!field.disabled) {
                    formik.setFieldValue("category_id", newValue);
                  }
                }}
                disabled={field.disabled}
                fullWidth
                sx={{
                  flexGrow: 1,
                  ".MuiAutocomplete-inputRoot": {
                    height: "40px",
                    padding: "0px !important", // Ensure consistent padding
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name={field.name}
                    error={
                      formik.touched[field.name] &&
                      Boolean(formik.errors[field.name])
                    }
                    helperText={
                      formik.touched[field.name] && formik.errors[field.name]
                    }
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                )}
              />
            ) : (
              <TextField
                disabled={field.disabled}
                id={field.name}
                name={field.name}
                type={field.type}
                value={formik.values[field.name]}
                onChange={formik.handleChange}
                {...getFieldProps(field.name)}
                error={
                  formik.touched[field.name] &&
                  Boolean(formik.errors[field.name])
                }
                helperText={
                  formik.touched[field.name] && formik.errors[field.name]
                }
                fullWidth
                InputProps={{
                  sx: { height: "40px", padding: "0px" }, // Ensure consistent height and padding
                  inputProps: {
                    style: {
                      "-moz-appearance": "textfield",
                      "-webkit-appearance": "none",
                      appearance: "none",
                    },
                    maxLength:
                      field.name === "idCardNumber"
                        ? 13
                        : field.name === "phoneNumber"
                        ? 10
                        : undefined,
                    inputMode: field.type === "text" ? "numeric" : undefined,
                    pattern: field.type === "text" ? "[0-9]*" : undefined,
                  },
                }}
              />
            )}
          </Box>
        </Grid>
      </React.Fragment>
    ));
  };

  const renderFieldsPayment = () => {
    return (
      <Box
        sx={{
          my: 2,
          border: "1px solid #ddd",
          p: 2,
          borderRadius: "12px",
          backgroundColor: "#ffffff",
        }}
      >
        <Grid container spacing={2} style={{ marginTop: "10px" }}>
          {/* Product Payment Channel Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  ช่องทางการชำระ{""}
                  <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Autocomplete
                  id={`payment_channel`}
                  options={payment_channelOptions}
                  getOptionLabel={(option) => option.label}
                  value={payment_channelOptions.find(
                    (option) => option.id === formik.values.payment_channel
                  )}
                  onChange={(event, newValue) => {
                    formik.setFieldValue(`payment_channel`, newValue);
                  }}
                  sx={{
                    ".MuiAutocomplete-inputRoot": {
                      height: "40px",
                      padding: "0px 0px 0px 5px !important",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name={`payment_channel`}
                      error={
                        formik.touched.payment_channel &&
                        Boolean(formik.errors.payment_channel)
                      }
                      helperText={
                        formik.touched.payment_channel &&
                        formik.errors.payment_channel
                      }
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        sx: { height: "40px" },
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Slip Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  หลักฐานการชำระเงิน{""}
                  <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Dropzone
                  files={files1}
                  setFiles={setFiles1}
                  setError={setError1}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Amount Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  จำนวนวันที่ยืม
                  <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  type="number"
                  name="return_date"
                  value={formik.values.return_date}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.return_date &&
                    Boolean(formik.errors.return_date)
                  }
                  helperText={
                    formik.touched.return_date && formik.errors.return_date
                  }
                  InputProps={{
                    sx: { height: "40px", padding: "0px" },
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Total Price Order Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>ราคารวม{""}</Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  disabled
                  name={`total_price_order`}
                  value={formik.values.total_price_order || sumTotalPrice || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur} // <-- Add onBlur
                  error={
                    formik.touched.total_price_order &&
                    Boolean(formik.errors.total_price_order)
                  }
                  helperText={
                    formik.touched.total_price_order &&
                    formik.errors.total_price_order
                  }
                  InputProps={{
                    sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Notes Order Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  หมายเหตุ{""}
                  <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  name={`notes_order`}
                  value={formik.values.notes_order || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur} // <-- Add onBlur
                  error={
                    formik.touched.notes_order &&
                    Boolean(formik.errors.notes_order)
                  }
                  helperText={
                    formik.touched.notes_order && formik.errors.notes_order
                  }
                  InputProps={{
                    sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  };

  // ฟังก์ชันการแสดงฟิลด์ของ Product
  const renderProductBoxes = () => {
    return productBoxes.map((box) => {
      const updateDataArray = Array.isArray(updateData)
        ? updateData
        : [updateData];

      // ดึงข้อมูลจาก updateData ตาม product_code
      const boxData =
        updateDataArray.find(
          (item) =>
            item.product_code === formik.values[`product_code_${box.id}`]
        ) || {};

      // Set field value for product_code only if it's different
      if (
        boxData.product_id &&
        formik.values[`product_id_${box.id}`] !== boxData.product_id
      ) {
        formik.setFieldValue(`product_id_${box.id}`, boxData.product_id);
        formik.setFieldValue(`price_${box.id}`, updateDataArray.price);
        formik.setFieldValue(`category_id_${box.id}`, boxData.category_id);
      }

      // console.log("Display updateData", updateDataArray);

      return (
        <Box
          key={box.id}
          sx={{
            my: 2,
            border: "1px solid #ddd",
            p: 2,
            borderRadius: "12px",
            backgroundColor: "#ffffff",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center" // Add this to center items vertically
            onClick={() => toggleExpand(box.id)}
          >
            <Typography variant="subtitle1">สินค้าชิ้นที่ {box.id}</Typography>
            <div>
              <IconButton
                disabled={productBoxes.length > 1 ? false : true}
                size="small"
                color="#ccc"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent toggleExpand from triggering on delete click
                  handleDeleteBox(box.id); // Call the delete function
                }}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                size="small"
                color="#ccc"
                onClick={() => handleExpandClick(box.id)}
                style={{
                  transform: expandedRow === box.id ? "rotate(180deg)" : "none",
                  transition: "transform 0.2s ease-in-out",
                  marginLeft: "10px",
                }}
              >
                <ExpandMoreIcon />
              </IconButton>
            </div>
          </Box>
          <Collapse in={box.isExpanded}>
            <Grid container spacing={2} style={{ marginTop: "10px" }}>
              <Divider sx={{ borderColor: "#00BB9F", borderWidth: 1 }} />
              {/* Product Code Row */}
              <Grid item xs={12}>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography>รหัสสินค้า {""}</Typography>
                    </div>
                  </Grid>

                  <Grid item xs={10}>
                    <TextField
                      fullWidth
                      name={`product_code_${box.id}`}
                      value={
                        formik.values[`product_code_${box.id}`] || ""
                        // boxData.product_code ||
                        // defaultValues.product_code
                      }
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched[`product_code_${box.id}`] &&
                        Boolean(formik.errors[`product_code_${box.id}`])
                      }
                      helperText={
                        formik.touched[`product_code_${box.id}`] &&
                        formik.errors[`product_code_${box.id}`]
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleCallData(
                            formik.values[`product_code_${box.id}`]
                          ); // ส่งค่าที่ถูกต้อง
                        }
                      }}
                      InputProps={{
                        sx: { height: "40px", padding: "0px" },
                        endAdornment: (
                          <IconButton
                            onClick={() =>
                              handleCallData(
                                formik.values[`product_code_${box.id}`]
                              )
                            } // ห่อฟังก์ชันใน arrow function
                            edge="end"
                            size="small"
                            sx={{
                              marginRight: "5px", // ขยับไอคอนมาด้านซ้าย
                            }}
                          >
                            <SearchIcon style={{ fontSize: "20px" }} />
                          </IconButton>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Product Code2 Row */}
              <Grid item xs={12}>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography>รหัส 2 {""}</Typography>
                      <Tooltip title="รหัสสินค้าภายในร้านที่สามารถกำหนดเองได้">
                        <InfoIcon
                          style={{ color: "#e5e5e5", marginRight: 10 }}
                        />
                      </Tooltip>
                    </div>
                  </Grid>

                  <Grid item xs={10}>
                    <TextField
                      disabled
                      fullWidth
                      name={`product_code_com_${box.id}`}
                      value={
                        formik.values[`product_code_com_${box.id}`] ||
                        boxData.product_code_com ||
                        ""
                      }
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur} // <-- Add onBlur
                      error={
                        formik.touched[`product_code_com_${box.id}`] &&
                        Boolean(formik.errors[`product_code_com_${box.id}`])
                      }
                      helperText={
                        formik.touched[`product_code_com_${box.id}`] &&
                        formik.errors[`product_code_com_${box.id}`]
                      }
                      InputProps={{
                        sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Product Name Row */}
              <Grid item xs={12}>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <Typography>
                      ชื่อสินค้า{""}
                      <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextField
                      disabled
                      fullWidth
                      name={`product_name_${box.id}`}
                      value={
                        formik.values[`product_name_${box.id}`] ||
                        boxData.product_name ||
                        ""
                      }
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur} // <-- Add onBlur
                      error={
                        formik.touched[`product_name_${box.id}`] &&
                        Boolean(formik.errors[`product_name_${box.id}`])
                      }
                      helperText={
                        formik.touched[`product_name_${box.id}`] &&
                        formik.errors[`product_name_${box.id}`]
                      }
                      InputProps={{
                        sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Product Category Row */}
              <Grid item xs={12}>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <Typography>
                      หมวดหมู่{""}
                      <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <Autocomplete
                      disabled
                      id={`category_id_${box.id}`}
                      options={categoryOptions}
                      getOptionLabel={(option) => option.label || ""} // Ensure label is retrieved correctly
                      value={
                        categoryOptions.find(
                          (option) =>
                            option.id ===
                            (formik.values[`category_id_${box.id}`] ||
                              boxData.category_id)
                        ) || null
                        // categoryOptions.find(
                        //   (option) =>
                        //     option.id ===
                        //       formik.values[`category_id_${box.id}`] ||
                        //     option.id === boxData.category_id
                        // )?.id ||
                        // boxData.category_id ||
                        // "" // Ensure default is selected if not set
                      }
                      onChange={(event, newValue) => {
                        formik.setFieldValue(
                          `category_id_${box.id}`,
                          newValue?.id || "" // Store only the id in Formik's state
                        );
                      }}
                      fullWidth
                      sx={{
                        ".MuiAutocomplete-inputRoot": {
                          height: "40px", // Set consistent height
                          padding: "0 8px", // Use slight padding to keep input structure intact
                        },
                        ".MuiOutlinedInput-root": {
                          height: "40px", // Ensure consistent height in outer wrapper
                        },
                        ".MuiAutocomplete-input": {
                          padding: "0px", // Minimal padding for input text
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name={`category_id_${box.id}`} // Use correct name for validation
                          error={
                            formik.touched[`category_id_${box.id}`] &&
                            Boolean(formik.errors[`category_id_${box.id}`])
                          }
                          helperText={
                            formik.touched[`category_id_${box.id}`] &&
                            formik.errors[`category_id_${box.id}`]
                          }
                          fullWidth
                          InputProps={{
                            ...params.InputProps,
                            sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Product Detail Row */}
              <Grid item xs={12}>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <Typography>รายละเอียด</Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextField
                      disabled
                      fullWidth
                      name={`detail_${box.id}`}
                      value={
                        formik.values[`detail_${box.id}`] ||
                        boxData.detail ||
                        ""
                      }
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur} // <-- Add onBlur
                      error={
                        formik.touched[`detail_${box.id}`] &&
                        Boolean(formik.errors[`detail_${box.id}`])
                      }
                      helperText={
                        formik.touched[`detail_${box.id}`] &&
                        formik.errors[`detail_${box.id}`]
                      }
                      InputProps={{
                        sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Product Blemishes Row */}
              <Grid item xs={12}>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <Typography>ตำหนิ</Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextField
                      disabled
                      fullWidth
                      name={`blemishes_${box.id}`}
                      value={
                        formik.values[`blemishes_${box.id}`] ||
                        boxData.blemishes ||
                        ""
                      }
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur} // <-- Add onBlur
                      error={
                        formik.touched[`blemishes_${box.id}`] &&
                        Boolean(formik.errors[`blemishes_${box.id}`])
                      }
                      helperText={
                        formik.touched[`blemishes_${box.id}`] &&
                        formik.errors[`blemishes_${box.id}`]
                      }
                      InputProps={{
                        sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Product Size Row */}
              <Grid item xs={12}>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <Typography>ขนาด</Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextField
                      disabled
                      fullWidth
                      name={`size_${box.id}`}
                      value={
                        formik.values[`size_${box.id}`] || boxData.size || ""
                      }
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur} // <-- Add onBlur
                      error={
                        formik.touched[`size_${box.id}`] &&
                        Boolean(formik.errors[`size_${box.id}`])
                      }
                      helperText={
                        formik.touched[`size_${box.id}`] &&
                        formik.errors[`size_${box.id}`]
                      }
                      InputProps={{
                        sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Product Total amount Row */}
              <Grid item xs={12}>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <Typography>
                      จำนวนในคลัง{" "}
                      <span style={{ color: "red", marginLeft: "3px" }}>*</span>
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextField
                      disabled
                      fullWidth
                      name={`total_amount_${box.id}`}
                      value={
                        formik.values[`total_amount_${box.id}`] ||
                        boxData.remaining_amount ||
                        ""
                      }
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched[`total_amount_${box.id}`] &&
                        Boolean(formik.errors[`total_amount_${box.id}`])
                      }
                      helperText={
                        formik.touched[`total_amount_${box.id}`] &&
                        formik.errors[`total_amount_${box.id}`]
                      }
                      InputProps={{
                        sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Product Price Row */}
              <Grid item xs={12}>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <Typography>
                      ราคาทุน/ชิ้น{""}
                      <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextField
                      disabled
                      fullWidth
                      name={`price_${box.id}`}
                      value={
                        formik.values[`price_${box.id}`] || boxData.price || ""
                      }
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched[`price_${box.id}`] &&
                        Boolean(formik.errors[`price_${box.id}`])
                      }
                      helperText={
                        formik.touched[`price_${box.id}`] &&
                        formik.errors[`price_${box.id}`]
                      }
                      InputProps={{
                        sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Product Total Price Row */}
              <Grid item xs={12}>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <Typography>
                      ราคารวม{""}
                      <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextField
                      fullWidth
                      name={`total_price_${box.id}`}
                      value={
                        formik.values[`total_amount_${box.id}`] &&
                        formik.values[`price_${box.id}`]
                          ? Number(formik.values[`total_amount_${box.id}`]) *
                            Number(formik.values[`price_${box.id}`])
                          : Number(boxData.total_amount) *
                              Number(boxData.price) || ""
                      }
                      // No onChange because total_price is calculated dynamically
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched[`total_price_${box.id}`] &&
                        Boolean(formik.errors[`total_price_${box.id}`])
                      }
                      helperText={
                        formik.touched[`total_price_${box.id}`] &&
                        formik.errors[`total_price_${box.id}`]
                      }
                      InputProps={{
                        sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                      }}
                      disabled // Disable input since it's calculated
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Product Notes Row */}
              <Grid item xs={12}>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <Typography>หมายเหตุ</Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextField
                      disabled
                      fullWidth
                      name={`notes_${box.id}`}
                      value={
                        formik.values[`notes_${box.id}`] || boxData.notes || ""
                      }
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur} // <-- Add onBlur
                      error={
                        formik.touched[`notes_${box.id}`] &&
                        Boolean(formik.errors[`notes_${box.id}`])
                      }
                      helperText={
                        formik.touched[`notes_${box.id}`] &&
                        formik.errors[`notes_${box.id}`]
                      }
                      InputProps={{
                        sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Product Total amount Row */}
              <Grid item xs={12}>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <Typography>
                      จำนวนที่ยืม{" "}
                      <span style={{ color: "red", marginLeft: "3px" }}>*</span>
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextField
                      fullWidth
                      name={`total_amount_borrow_${box.id}`}
                      value={
                        formik.values[`total_amount_borrow_${box.id}`] ||
                        boxData.total_amount_borrow_ ||
                        ""
                      }
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched[`total_amount_borrow_${box.id}`] &&
                        Boolean(formik.errors[`total_amount_borrow_${box.id}`])
                      }
                      helperText={
                        formik.touched[`total_amount_borrow_${box.id}`] &&
                        formik.errors[`total_amount_borrow_${box.id}`]
                      }
                      InputProps={{
                        sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Product Price Row */}
              <Grid item xs={12}>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <Typography>
                      ราคายืม/ชิ้น{""}
                      <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextField
                      fullWidth
                      name={`price_borrow_${box.id}`}
                      value={
                        formik.values[`price_borrow_${box.id}`] ||
                        boxData.price_borrow_ ||
                        ""
                      }
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched[`price_borrow_${box.id}`] &&
                        Boolean(formik.errors[`price_borrow_${box.id}`])
                      }
                      helperText={
                        formik.touched[`price_borrow_${box.id}`] &&
                        formik.errors[`price_borrow_${box.id}`]
                      }
                      InputProps={{
                        sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Product Total Price Row */}
              <Grid item xs={12}>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <Typography>
                      ราคารวม{""}
                      <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextField
                      fullWidth
                      disabled
                      name={`total_price_borrow_${box.id}`}
                      value={
                        formik.values[`total_amount_borrow_${box.id}`] &&
                        formik.values[`price_borrow_${box.id}`]
                          ? Number(
                              formik.values[`total_amount_borrow_${box.id}`]
                            ) * Number(formik.values[`price_borrow_${box.id}`])
                          : ""
                      }
                      // No onChange because total_price is calculated dynamically
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched[`total_price_${box.id}`] &&
                        Boolean(formik.errors[`total_price_${box.id}`])
                      }
                      helperText={
                        formik.touched[`total_price_${box.id}`] &&
                        formik.errors[`total_price_${box.id}`]
                      }
                      InputProps={{
                        sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Product Image Row */}
              <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ mb: 2 }}>
                  รูปทรัพย์
                </Typography>
                <Grid item xs={12}>
                  <div>
                    {Array.isArray(boxData.Pictures) &&
                    boxData.Pictures.length > 0 ? (
                      <div>
                        {boxData.Pictures.map((picture, index) => (
                          // console.log("picture", picture),
                          <img
                            key={index}
                            src={picture.pic} // หรือ picture.path หรือคีย์ที่เก็บ URL รูปภาพ
                            alt={`Image ${index + 1} for Box ${box.id}`}
                            style={{
                              width: "150px",
                              height: "150px",
                              objectFit: "cover",
                              marginRight: "10px",
                            }}
                          />
                        ))}
                      </div>
                    ) : (
                      <p>No images available for Box {box.id}</p>
                    )}
                  </div>
                </Grid>

                {error1 && (
                  <Typography variant="caption" color="error">
                    {error1}
                  </Typography>
                )}
              </Grid>
            </Grid>
          </Collapse>
        </Box>
      );
    });
  };

  // console.log("display formik.values", formik.values);
  //กรณีปิดหน้าต่าง Modal
  const handleCancel = () => {
    const formHasUnsavedChanges = Object.keys(touched).some(
      (field) => touched[field]
    );

    // console.log('formHasUnsavedChanges', formHasUnsavedChanges);
    // Prompt the user to confirm before closing if there are unsaved changes
    if (formHasUnsavedChanges) {
      Swal.fire({
        html: `
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <!-- Left side icon/picture -->
            <div style="margin-right: 20px;">
              <img src="${SaveIcon}" alt="warning icon" width="300" height="300"/>
            </div>
      
            <!-- Right side text and buttons -->
            <div style="flex: 1;">
              <h2 style="font-size: 24px; color: #333;">ยืนยันการบันทึกหรือไม่</h2>
              <div id="custom-buttons" style="display: flex; justify-content: flex-end; margin-top: 20px;">
                <!-- React buttons will be injected here -->
              </div>
            </div>
          </div>
        `,
        showCancelButton: false, // Disable default buttons
        showConfirmButton: false, // Disable default buttons
        customClass: {
          container: "swal2-container-custom",
        },
        didOpen: () => {
          document.querySelector(".swal2-container-custom").style.zIndex = 1500;

          // Render your React button components after the Swal modal opens
          ReactDOM.render(
            <>
              <GradientButton
                onClick={() => {
                  // Handle cancel behavior
                  Swal.close(); // Close Swal
                }}
                style={{ width: "100%", marginBottom: "10px" }} // Make full width
              >
                ยกเลิก
              </GradientButton>
              <GradientButtonOutline
                onClick={() => {
                  // Close the current Swal first before showing the confirmation Swal
                  Swal.close();
                  formik.resetForm();
                  setFiles1([]); // Clear product images
                  setFiles2([]); // Clear customer images
                  setInitialProductUrls([]); // Clear initial product image URLs
                  // setInitialCustomerUrls([]);
                  setDeletedImageIds([]);
                  onClose();
                  setNewIds([]);
                  handleClose();
                }}
                style={{ width: "100%" }}
              >
                ตกลง
              </GradientButtonOutline>
            </>,
            document.getElementById("custom-buttons") // Inject React components into this div
          );
        },
      });
    } else {
      formik.resetForm();
      setFiles1([]); // Clear product images
      setFiles2([]); // Clear customer images
      setInitialProductUrls([]); // Clear initial product image URLs
      // setInitialCustomerUrls([]);
      setDeletedImageIds([]);
      onClose();
      setNewIds([]);
    }
  };

  // Function to handle button click
  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName); // Set the clicked button as active
  };

  const { errors, touched, getFieldProps, handleSubmit } = formik;

  // ใช้สำหรับการคิดค่าของ ราคา * จำนวน = จำนวนทั้งหมดแล้วนำไปเก็บไว้ใน Formik id นั้นๆ
  useEffect(() => {
    let totalSum = 0;

    productBoxes.forEach((box) => {
      const totalAmount = formik.values[`total_amount_${box.id}`];
      const price = formik.values[`price_${box.id}`];
      const totalAmountLenting = formik.values[`total_amount_borrow_${box.id}`];
      const priceBorrow = formik.values[`price_borrow_${box.id}`];

      if (totalAmount && price) {
        const totalPrice = Number(totalAmount) * Number(price);
        formik.setFieldValue(`total_price_${box.id}`, totalPrice);
      }

      if (totalAmountLenting && priceBorrow) {
        const totalPrice = Number(totalAmountLenting) * Number(priceBorrow);
        totalSum += totalPrice; // รวม total_price
      }
    });

    // เก็บผลรวมใน sumTotalPrice
    setSumTotalPrice(totalSum);
  }, [formik.values, formik.setFieldValue, productBoxes]);

  // console.log("Display updateData formik.values", formik.values);

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        //ป้องกันการกดเบื้องหลังแล้วหลุด
        if (reason !== "backdropClick") onClose();
      }}
      disableEscapeKeyDown
      fullWidth
      maxWidth="lg"
      sx={{
        borderRadius: "8px",
      }}
    >
      {currentStep === 1 ? (
        <>
          {/* หน้าที่ 1 : Form */}
          <DialogTitle style={{ backgroundColor: "#F1F2F7" }}>
            <Typography variant="h4">สร้างรายการยืม</Typography>
          </DialogTitle>
          <DialogContent style={{ backgroundColor: "#F1F2F7" }}>
            <form onSubmit={formik.handleSubmit}>
              {/* Render the product boxes */}
              <Grid item xs={12} sx={{ mx: 2 }}>
                <Typography sx={{ mb: 1, ml: 2 }} variant="h5">
                  ข้อมูลลูกค้า
                </Typography>
                <Paper sx={{ p: 2, borderRadius: "12px" }}>
                  <Grid container>
                    <Grid item xs={7}>
                      {renderFields(customerFields)}
                    </Grid>
                    <Grid item xs={5} sx={{ mt: 2 }}>
                      {selectedProduct ? (
                        <img
                          src={selectedProduct.customer_image}
                          alt="Preview"
                          style={{
                            width: "200px",
                            height: "200px",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <Dropzone
                          files={files2}
                          setFiles={setFiles2}
                          setError={setError2}
                        />
                      )}
                      {error2 && (
                        <Typography variant="caption" color="error">
                          {error2}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </Paper>

                <Grid items xs={12}>
                  {/* Render the product boxes */}
                  <Typography sx={{ mb: 2, mt: 3, ml: 2 }} variant="h5">
                    ข้อมูลสินค้า
                  </Typography>
                  {renderProductBoxes()}
                </Grid>

                {/* Button to add new product box and display count */}
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-end"
                  sx={{ mt: 2 }}
                >
                  <Typography>{productBoxCount} / 15</Typography>
                  {productBoxes.length >= 15 ? (
                    <GradientOutline
                      // onClick={addProductBox}
                      disabled={productBoxes.length >= 15}
                      style={{ marginLeft: "10px" }}
                    >
                      <Typography style={{ marginRight: "8px" }}>
                        เพิ่มสินค้า
                      </Typography>
                      <AddCircleIcon fontSize="medium" />
                    </GradientOutline>
                  ) : (
                    <GradientButton
                      onClick={addProductBox}
                      style={{ marginLeft: "10px" }}
                    >
                      <Typography style={{ marginRight: "8px" }}>
                        เพิ่มสินค้า
                      </Typography>
                      <AddCircleIcon fontSize="medium" />
                    </GradientButton>
                  )}
                </Box>

                <Grid items xs={12}>
                  {/* Render the product boxes */}
                  <Typography sx={{ mb: 2, mt: 3, ml: 2 }} variant="h5">
                    เงื่อนไขการยืม
                  </Typography>
                  {renderFieldsPayment()}
                </Grid>
              </Grid>
            </form>
          </DialogContent>

          <DialogActions
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 16px 16px 16px",
              backgroundColor: "#F1F2F7",
            }}
          >
            {/* Dialog Actions */}
            <Grid container sx={{ mx: 3 }}>
              <Grid item xs={12}>
                <Divider
                  style={{
                    marginTop: "0",
                    marginBottom: "16px",
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                container
                justifyContent="space-between" // Apply flex properties to align buttons
              >
                <Button
                  variant="outlined"
                  onClick={handleCancel}
                  sx={{
                    borderRadius: "12px", // Make the button circular
                    minWidth: "40px", // Adjust the width
                    minHeight: "40px", // Adjust the height
                    padding: 0, // Remove padding to center the icon better
                    borderColor: "#c4c4c4", // Light grey border
                    color: "#6c6c6c", // Light grey icon color
                    display: "flex", // Ensure flexbox is used
                    alignItems: "center", // Center vertically
                    justifyContent: "center", // Center horizontally
                    "&:hover": {
                      borderColor: "#a0a0a0", // Darker grey on hover
                    },
                  }}
                >
                  <ArrowBackIosIcon
                    fontSize="small"
                    style={{
                      marginLeft: "5px",
                    }}
                  />
                </Button>
                <GradientButtonOutline type="submit" onClick={handleNextStep}>
                  ดูตัวอย่าง
                </GradientButtonOutline>
              </Grid>
            </Grid>
          </DialogActions>
        </>
      ) : (
        <>
          {/* Step 2: Confirmation Page */}
          <DialogTitle>
            <Typography variant="h4">ตัวอย่างแบบฟอร์มรายการยืม</Typography>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              {/* Left Side: PDF Preview (Scrollable) */}
              <Grid
                item
                xs={8}
                style={{
                  backgroundColor: "#f0f0f0",
                  padding: "20px",
                  height: "650px",
                  overflowY: "scroll",
                  overflowX: "hidden",
                }}
              >
                <Form data={formik.values} />
              </Grid>

              {/* Right Side: The Form or other content */}
              <Grid
                item
                xs={4}
                display={"flex"}
                flexDirection={"column"}
                style={{ padding: "20px" }}
              >
                <GradientShadow
                  isActive={activeButton === "pawnContract"}
                  onClick={() => handleButtonClick("pawnContract")}
                  style={{ margin: "10px" }}
                >
                  ใบเสร็จรับเงิน
                </GradientShadow>

                {/* <GradientShadow
                  isActive={activeButton === "saleRenewal"}
                  onClick={() => handleButtonClick("saleRenewal")}
                  style={{ margin: "10px" }}
                >
                  ใบขายฝาก / ต่ออายุ
                </GradientShadow> */}
                {/* Content for the right side */}
              </Grid>
            </Grid>
          </DialogContent>

          {/* <Divider style={{ marginTop: "0", marginBottom: "16px", mx: 2 }} /> */}

          <DialogActions
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 16px 16px 16px",
              // backgroundColor: "#F1F2F7",
            }}
          >
            {/* Dialog Actions */}
            <Grid container sx={{ mx: 3 }}>
              <Grid item xs={12}>
                <Divider
                  style={{
                    marginTop: "0",
                    marginBottom: "16px",
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                container
                justifyContent="space-between" // Apply flex properties to align buttons
              >
                <GradientButtonOutline
                  // GradientButtonOutlineon
                  onClick={handleBackToStep1}
                >
                  ยกเลิก
                </GradientButtonOutline>
                <Grid>
                  {isSuccess ? (
                    <>
                      <GradientButtonOutline
                        sx={{
                          width: "120px",
                          marginRight: "20px",
                        }}
                        endIcon={
                          <CheckCircleIcon
                            sx={{
                              width: "16px",
                              height: "16px",
                            }}
                          />
                        }
                        id="btn-success"
                        onClick={handleClose}
                      >
                        เสร็จสิ้น
                      </GradientButtonOutline>
                      <GradientButton
                        id="btn-print-pdf"
                        onClick={handlePrintPDF}
                        sx={{ width: "100px" }}
                      >
                        พิมพ์
                      </GradientButton>
                    </>
                  ) : (
                    <>
                      <GradientButton
                        type="submit"
                        onClick={formik.handleSubmit}
                        style={{ marginRight: "20px", width: "150px" }}
                        disabled={loading}
                        endIcon={
                          loading ? (
                            <CircularProgress
                              color="inherit"
                              size={15}
                              thickness={5}
                            />
                          ) : null
                        }
                      >
                        บันทึก
                      </GradientButton>
                      <Tooltip
                        title={
                          <Typography
                            sx={{
                              fontSize: "14px",
                            }}
                          >
                            กรุณากดบันทึกก่อนพิมพ์
                          </Typography>
                        }
                        arrow={true}
                        placement="top"
                        disableHoverListener={isSuccess} // ปิด tooltip ถ้า isSuccess = true
                        disableFocusListener={isSuccess}
                      >
                        <span>
                          <GradientButtonOutline
                            disabled={!isSuccess}
                            sx={{
                              width: "100px",
                              border: "1px solid #ccc",
                            }}
                          >
                            พิมพ์
                          </GradientButtonOutline>
                        </span>
                      </Tooltip>
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default ModalBorrow;
